<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'NATOverloadList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              NAT
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">NAT</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="NATOverload">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1 || is_copy" class="form-group required">
                    <label class="control-label">Audra</label>

                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>

                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      v-bind:class="{ 'has-error': errors.has('name') }"
                      :readonly="is_edit"
                      v-validate="'required'"
                      v-model="value.name"
                      class="form-control name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>

                  <!-- <div class="form-group required">
                    <label class="control-label">Type</label>
                    <multiselect
                      v-model="value.type"
                      :options="pre.types"
                      placeholder="Select Type"
                      :searchable="true"
                      :multiple="false"
                      id="type"
                      v-bind:class="{ 'has-error': errors.has('type') }"
                      v-validate="'required'"
                      name="type"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('type')">
                      {{ errors.first('type') }}
                    </div>
                  </div> -->
                  <div class="form-group">
                    <label class="control-label">Type</label>
                    <div style="gap: 10px" class="flex-wrap d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(type, index) in [
                          'One To One',
                          'Interface Overload',
                          'IP Overload',
                          'Destination-Nat',
                        ]"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="type"
                          v-model="value.type"
                          name="type"
                          id="type"
                          v-validate="'required'"
                          :disabled="is_edit"
                        />
                        <span class="radio-mark"></span>{{ type.toUpperCase() }}
                      </label>
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Include</label>

                    <select
                      class="form-control"
                      name="include"
                      v-bind:class="{ 'has-error': errors.has('include') }"
                      id="include"
                      v-model="value.include"
                    >
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </select>
                  </div> -->
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Destination Address Include</label>
                      </div>
                      <label class="switch ml-auto"
                        ><input
                          type="checkbox"
                          name="include"
                          id="include"
                          value="1"
                          v-model="value.include" />
                        <div class="slider round"></div
                      ></label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Destination IP</label>
                    <input
                      type="text"
                      id="destination_ip"
                      name="destination_ip"
                      v-bind:class="{
                        'has-error': errors.has('destination_ip'),
                      }"
                      v-validate="'ip_CIDR'"
                      v-model="value.destination_ip"
                      class="form-control destination_ip"
                      placeholder="0.0.0.0/0"
                    />
                    <div class="help text-danger" v-show="errors.has('destination_ip')">
                      {{ errors.first("destination_ip") }}
                    </div>
                  </div>
                  <div
                    class="form-group required"
                    v-if="value.type === 'Interface Overload'"
                  >
                    <label class="control-label">Interface</label>
                    <multiselect
                      v-model="value.interface"
                      :options="Object.keys(pre.interfaceList)"
                      :custom-label="(opt) => pre.interfaceList[opt]"
                      placeholder="Select interface"
                      :searchable="true"
                      :multiple="false"
                      id="interface"
                      v-validate="'required'"
                      v-bind:class="{ 'has-error': errors.has('interface') }"
                      name="interface"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('interface')">
                      {{ errors.first("interface") }}
                    </div>
                  </div>

                  <div class="form-group" v-if="value.type === 'Destination-Nat'">
                    <label class="control-label">Interface</label>
                    <multiselect
                      v-model="value.interface"
                      :options="Object.keys(pre.interfaceList)"
                      :custom-label="(opt) => pre.interfaceList[opt]"
                      placeholder="Select interface"
                      :searchable="true"
                      :multiple="false"
                      id="interface"
                      v-bind:class="{ 'has-error': errors.has('interface') }"
                      name="interface"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('interface')">
                      {{ errors.first("interface") }}
                    </div>
                  </div>

                  <div v-if="value.type === 'One To One'">
                    <div class="form-group required">
                      <label class="control-label">Source IP Address</label>
                      <input
                        type="text"
                        id="source_ip"
                        name="source ip"
                        v-bind:class="{ 'has-error': errors.has('source_ip') }"
                        v-validate="'required|ip'"
                        v-model="value.source_ip"
                        class="form-control source_ip"
                        placeholder="Example: 192.168.20.1"
                      />
                      <div class="help text-danger" v-show="errors.has('source ip')">
                        {{ errors.first("source ip") }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">To Source IP</label>
                      <input
                        type="text"
                        id="source_ip_to"
                        name="to source ip"
                        v-bind:class="{
                          'has-error': errors.has('source_ip_to'),
                        }"
                        v-validate="'required|ip'"
                        v-model="value.source_ip_to"
                        class="form-control source_ip_to"
                        placeholder="Example: 192.168.20.0"
                      />
                      <div class="help text-danger" v-show="errors.has('to source ip')">
                        {{ errors.first("to source ip") }}
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    v-if="value.type == 'Interface Overload'"
                    class="form-group"
                  >
                    <label class="control-label">Include</label>
                    <select
                      class="form-control"
                      name="interface_overload_include"
                      v-bind:class="{
                        'has-error': errors.has('interface_overload_include'),
                      }"
                      id="interface_overload_include"
                      v-model="value.interface_overload_include"
                    >
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </select>
                  </div> -->

                  <div class="form-group" v-if="value.type === 'Interface Overload'">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Source Address Include</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="interface_overload_include"
                          id="interface_overload_include"
                          v-model="value.interface_overload_include"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>

                  <div v-if="value.type === 'Interface Overload'" class="form-group">
                    <label class="control-label">Source IP Address</label>
                    <input
                      type="text"
                      id="interface_source_ip"
                      name="interface source ip"
                      v-bind:class="{
                        'has-error': errors.has('interface_source_ip'),
                      }"
                      v-validate="'ip_CIDR'"
                      v-model="value.interface_source_ip"
                      class="form-control interface_source_ip"
                      placeholder="Example: 192.168.20.1/24"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('interface source ip')"
                    >
                      {{ `The input format is invalid. Valid Format : 192.168.20.0/24` }}
                    </div>
                  </div>

                  <div v-if="value.type === 'IP Overload'">
                    <div class="form-group">
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">Source Address Include</label>
                        </div>
                        <label class="switch ml-auto"
                          ><input
                            type="checkbox"
                            name="ip_overload_include"
                            id="ip_overload_include"
                            true-value="1"
                            false-value="0"
                            v-model="value.ip_overload_include" />
                          <div class="slider round"></div
                        ></label>
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Source IP Address</label>
                      <input
                        type="text"
                        id="ip_source_ip"
                        name="source ip address"
                        v-bind:class="{
                          'has-error': errors.has('ip_source_ip'),
                        }"
                        v-validate="'required|ip_CIDR'"
                        v-model="value.ip_source_ip"
                        class="form-control ip_source_ip"
                        placeholder="Example: 192.168.20.1/24"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('source ip address')"
                      >
                        {{
                          `The input format is invalid. Valid Format : 192.168.20.0/24`
                        }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">To Source IP</label>
                      <input
                        type="text"
                        id="ip_to_source_ip"
                        name="to source ip"
                        v-bind:class="{
                          'has-error': errors.has('ip_to_source_ip'),
                        }"
                        v-validate="'required|ip'"
                        v-model="value.ip_to_source_ip"
                        class="form-control ip_to_source_ip"
                        placeholder="Example: 192.168.20.1"
                      />
                      <div class="help text-danger" v-show="errors.has('to source ip')">
                        {{ errors.first("to source ip") }}
                      </div>
                    </div>
                  </div>

                  <div v-if="value.type === 'Destination-Nat'">
                    <!-- <div class="form-group">
                      <label class="control-label">Include</label>

                      <select
                        class="form-control"
                        name="destination_include"
                        v-bind:class="{
                          'has-error': errors.has('destination_include'),
                        }"
                        id="destination_include"
                        v-model="value.destination_include"
                      >
                        <option :value="1">Yes</option>
                        <option :value="0">No</option>
                      </select>
                    </div> -->
                    <div class="form-group">
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">Source Address Include</label>
                        </div>
                        <label class="switch ml-auto"
                          ><input
                            type="checkbox"
                            name="destination_include"
                            id="destination_include"
                            true-value="1"
                            false-value="0"
                            v-model="value.destination_include" />
                          <div class="slider round"></div
                        ></label>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Source IP Address</label>
                      <input
                        type="text"
                        id="nat_source_ip"
                        name="nat source ip"
                        v-bind:class="{
                          'has-error': errors.has('nat_source_ip'),
                        }"
                        v-validate="'ip_CIDR'"
                        v-model="value.nat_source_ip"
                        class="form-control nat_source_ip"
                        placeholder="Example: 192.168.20.1/24"
                      />
                      <div class="help text-danger" v-show="errors.has('nat source ip')">
                        {{
                          `The input format is invalid. Valid Format : 192.168.20.0/24`
                        }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Host IP</label>
                      <input
                        type="text"
                        id="destination_to_ip"
                        name="host ip"
                        v-bind:class="{
                          'has-error': errors.has('destination_to_ip'),
                        }"
                        v-validate="'required|ip'"
                        v-model="value.destination_to_ip"
                        class="form-control destination_to_ip"
                        placeholder="Example: 192.168.20.0"
                      />
                      <div class="help text-danger" v-show="errors.has('host ip')">
                        {{ errors.first("host ip") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Protocol</label>

                      <!-- <select
                        class="form-control"
                        name="destination_nat_protocol"
                        v-bind:class="{
                          'has-error': errors.has('destination_nat_protocol'),
                        }"
                        id="destination_nat_protocol"
                        v-model="value.destination_nat_protocol"
                      >
                        <option value="">Select</option>
                        <option value="TCP">TCP</option>
                        <option value="UDP">UDP</option>
                        <option value="BOTH">BOTH</option>
                      </select> -->
                      <!-- <div class="d-flex">
                        <label
                          class="radio mr-3"
                          v-for="(destination_nat_protocol, index) in [
                            'TCP',
                            'UDP',
                            'BOTH'
                          ]"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="protocol"
                            v-model="value.destination_nat_protocol"
                            name="destination_nat_protocol"
                            v-validate="'required'"
                            id="destination_nat_protocol"
                          />
                          <span class="radio-mark"></span
                          >{{ destination_nat_protocol }}
                        </label>
                      </div> -->
                      <div style="gap: 10px" class="d-flex flex-wrap">
                        <label
                          class="radio mr-3"
                          v-for="(destination_nat_protocol, index) in [
                            'TCP',
                            'UDP',
                            'BOTH',
                          ]"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="destination_nat_protocol"
                            v-model="value.destination_nat_protocol"
                            name="destination_nat_protocol"
                            v-validate="'required'"
                            id="destination_nat_protocol"
                          />
                          <span class="radio-mark"></span>
                          {{ destination_nat_protocol }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">From Port</label>
                      <input
                        type="text"
                        id="destination_form_port"
                        name="form port"
                        v-bind:class="{
                          'has-error': errors.has('destination_form_port'),
                        }"
                        v-validate="'required|numeric|min:1'"
                        v-model="value.destination_form_port"
                        class="form-control destination_form_port"
                        placeholder="Example: 80"
                      />
                      <div class="help text-danger" v-show="errors.has('form port')">
                        {{ errors.first("form port") }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">To Port</label>
                      <input
                        type="text"
                        id="destination_to_port"
                        name="to port"
                        v-bind:class="{
                          'has-error': errors.has('destination_to_port'),
                        }"
                        v-validate="'required|numeric|min:1'"
                        v-model="value.destination_to_port"
                        class="form-control destination_to_port"
                        placeholder="Example: 90"
                      />
                      <div class="help text-danger" v-show="errors.has('to port')">
                        {{ errors.first("to port") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "NATOverloadForm",
  metaInfo: {
    title: "NAT Overload | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),

    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    is_copy: false,
    params: {},

    value: {
      include: 1,
      interface_overload_include: 1,
      ip_overload_include: 1,
      destination_include: 1,
      destination_nat_protocol: "TCP",
    },
    pre: {
      audraName: [],
      types: ["One To One", "Interface Overload", "IP Overload", "Destination-Nat"],
      interfaceList: [],
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/nat_overloads";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/nat_overloads/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "NATOverloadList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          const errors = _this.$validator.errors.items;
          console.error("Validation failed for the following fields:");
          errors.forEach((error) => {
            console.error(`Field: ${error.field}, Message: ${error.msg}`);
          });
          // _this.$toaster.error("Validation failed. Please check the form for errors.");
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/nat_overloads/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getInterfaceList: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-interface-list", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (
        !_.isEmpty(this.params) &&
        this.params.id !== undefined &&
        this.params.isCopy !== undefined
      ) {
        this.is_copy = true;
      } else if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit || this.is_copy) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            this.value.source_ip_to = this.value.to_ource_ip;
            this.value.interface_overload_include =
              response.data.interface_overload_include || 0;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.include = 1;
        this.value.destination_ip = "0.0.0.0/0";
      }
      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      await this.getInterfaceList()
        .then((response) => {
          this.pre.interfaceList = response.data;
          console.log(this.pre.interfaceList);
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
      this.setCustomValidation();
    },

    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value);
        },
      });
    },

    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
